export default __webpack_public_path__ + "media/images/user_photos/133-dd31532fd9034f2900608375d47aa739.jpg";